import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/acp-mobile-sdkdocs/acp-mobile-sdkdocs/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "release-notes"
    }}>{`Release notes`}</h1>
    <h2 {...{
      "id": "august-1-2023"
    }}>{`August 1, 2023`}</h2>
    <h3 {...{
      "id": "android-mobile-core-1116"
    }}>{`Android Mobile Core 1.11.6`}</h3>
    <ul>
      <li parentName="ul">{`Implemented database recovery in SQLiteDataQueue for cases where adding or removing an entry fails due to unexpected errors.`}</li>
    </ul>
    <h2 {...{
      "id": "march-29-2023"
    }}>{`March 29, 2023`}</h2>
    <h3 {...{
      "id": "android-mobile-core-1115"
    }}>{`Android Mobile Core 1.11.5`}</h3>
    <ul>
      <li parentName="ul">{`Fixed crash when initializing SDK in Android direct boot mode. `}</li>
    </ul>
    <h2 {...{
      "id": "march-2-2023"
    }}>{`March 2, 2023`}</h2>
    <h3 {...{
      "id": "ios-acpcore-297"
    }}>{`iOS ACPCore 2.9.7`}</h3>
    <ul>
      <li parentName="ul">{`Fix race conditions in StringUtils.`}</li>
    </ul>
    <h2 {...{
      "id": "february-13-2023"
    }}>{`February 13, 2023`}</h2>
    <h3 {...{
      "id": "android-campaign-standard-1010"
    }}>{`Android Campaign Standard 1.0.10`}</h3>
    <ul>
      <li parentName="ul">{`Fixed a crash which could occur when loading Campaign in-app messages.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      